import { FieldStyle } from './fieldstyle';
export class Column {
    constructor() {
        this.header = new FieldStyle();
        this.cell = new FieldStyle();
    }
    colName: string;
    displayName: string;
    checked: boolean;
    selected: boolean;
    colOrder: number;
    dataType: string;
    thousandSepartor: string;
    decimalPlaces: number;
    currencySymbol: string;
    fontSize: number;
    fontWeight: string;
    fontStyle: string;
    textOrientation: string;
    dateFormat: string;
    header: FieldStyle;
    cell: FieldStyle;
    valueField: boolean;
    formula: string;
    fields: any[];
}
